// Voeg een "angle" span toe aan alle elementen met de klasse "menu-item-has-children"
$('.menu-item-has-children').append("<span class='angle'></span>");

// Selecteer alle elementen met de klasse "menu-item-has-children"
const menuItemHasChildren = document.querySelectorAll('.menu-item-has-children');
const bodyOverlays = document.querySelectorAll('.body__overlay');

// Voeg event listeners toe aan de elementen met de klasse "menu-item-has-children"
menuItemHasChildren.forEach(item => {
    // Wanneer de muis over het element beweegt
    item.addEventListener('mouseover', () => {
        // Voeg de klasse "body__overlay--active" toe aan alle "body__overlay" elementen
        bodyOverlays.forEach(overlay => {
            overlay.classList.add('body__overlay--active');
        });
    });

    // Wanneer de muis het element verlaat
    item.addEventListener('mouseout', () => {
        // Verwijder de klasse "body__overlay--active" van alle "body__overlay" elementen
        bodyOverlays.forEach(overlay => {
            overlay.classList.remove('body__overlay--active');
        });
    });
});

// Voeg de klasse "sub-menu--second" toe en verwijder de klasse "sub-menu" van alle elementen met de klasse "menu-item-has-children" binnen elementen met de klasse "sub-menu"
$('.sub-menu .menu-item-has-children').find('.sub-menu').addClass('sub-menu--second').removeClass('sub-menu');

// Voeg de klasse "menu-item-has-children-sub" toe aan alle elementen met de klasse "menu-item-has-children" binnen elementen met de klasse "sub-menu"
$('.sub-menu').find('.menu-item-has-children').addClass('menu-item-has-children-sub');

// Controleer of de elementen met de klasse "menu-item-has-children" een element met de klasse "submenu-breed" bevatten
$('.menu-item-has-children').is(function() {
    if ($(this).find("span.submenu-breed").length) {
        // Verwijder de klasse "small-submenu" en geef "true" terug
        $(this).removeClass("small-submenu");
        return true;
    }
    return false;
});

// Als het venster breder is dan 1024 pixels
function wrapSubMenuElements() {
  if ($(window).width() > 1024) {
    $('.sub-menu:not(.container-fluid--menu)').each(function() {
      if (!$(this).closest('.container-fluid--menu').length) {
        $(this).wrap('<span class="container-fluid container-fluid--menu"></span>');
      }
    });

    $('.container-fluid--menu:not(.menu-container)').each(function() {
      if (!$(this).closest('.menu-container').length) {
        $(this).wrap('<span class="menu-container"></span>');
      }
    });

    $('.small-submenu').each(function() {
      $(this).find('.sub-menu').unwrap('.menu-container');
      $(this).find('.sub-menu').unwrap('.container-fluid--menu');
    });
  } else {
    // Breng eventuele wijzigingen aan voor kleinere schermformaten
  }
}

$(document).ready(function() {
  wrapSubMenuElements();
});

$(window).resize(function() {
  wrapSubMenuElements();
});


// Wanneer er op "#open__mobile" wordt geklikt
$('#open__mobile').click(function(){
    // Toggle de klasse "nav-primary--active" van ".nav-primary"
    $('.nav-primary').toggleClass("nav-primary--active");
    // Wissel de weergave van "#hamburger__open" en "#hamburger__closed"
    $('#hamburger__open').toggle();
    $('#hamburger__closed').toggle();
    setTimeout(function(){
        // Toggle de klasse "body--active" van "body" na 400 milliseconden
        $('body').toggleClass("body--active");
    }, 400); 
});

// Wanneer er op een link binnen ".nav-primary" wordt geklikt
$('.nav-primary a').click(function(){
    // Wissel de weergave van "#hamburger__open" en "#hamburger__closed"
    $('#hamburger__open').toggle();
    $('#hamburger__closed').toggle();
});

// Wanneer er op een element met de klasse "angle" wordt geklikt
$('.angle').click(function(){
    // Toggle de klasse "angle-up" van het geklikte element
    $(this).toggleClass('angle-up');
    // Toggle de klasse "sub-menu--active" van het eerste ".sub-menu" element binnen het ouderelement van het geklikte element
    $(this).parent().find('.sub-menu').first().toggleClass('sub-menu--active');
});

// Wanneer er op een element met de klasse "angle" binnen een ".sub-menu" wordt geklikt
$('.sub-menu').find('.angle').click(function(){
    // Toggle de klasse "angle-up" van het geklikte element
    $(this).find('.angle').toggleClass('angle-up');
    // Toggle de klasse "sub-menu--active" van het eerste ".sub-menu--second" element binnen het ouderelement van het geklikte element
    $(this).parent().find('.sub-menu--second').first().toggleClass('sub-menu--active');
});

// Variabele om de vorige scrollpositie bij te houden
var lastScrollTop = 0;

// Wanneer er wordt gescrold
$(window).scroll(function(event){
    var st = $(this).scrollTop();
    if (st > lastScrollTop){
        // Scroll naar beneden
        $('.header__right').addClass('header__right--sticky');
        $('.brand').addClass('brand--small');
        $('.nav-primary').find('.menu-item').removeClass('3xl:py-14').addClass('3xl:py-10');
        $('.nav-primary').find('.menu-item').removeClass('lg:py-10').addClass('lg:py-8');
        $('.menu-container').addClass('menu-container--sticky');
    } else {
        // Scroll naar boven
        $('.header__right').removeClass('header__right--sticky');
        $('.brand').removeClass('brand--small');
        $('.nav-primary').find('.menu-item').removeClass('3xl:py-10').addClass('3xl:py-14');
        $('.nav-primary').find('.menu-item').removeClass('lg:py-8').addClass('lg:py-10');
        $('.menu-container').removeClass('menu-container--sticky');
    }
    lastScrollTop = st;
});
